import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {membersApi} from '../http/Api';

export const getMembers = createAsyncThunk('Members/getMembers', async (payload, thunkAPI) => {
  const {serverId} = thunkAPI.getState().serverId;
  const response = await membersApi.getMembers(serverId);

  if (response.status === 200) {
    thunkAPI.dispatch(membersSlice.actions.setMembers(response));
  }
});

const initialState = {
  membersGlobalState: null,
};

const membersSlice = createSlice({
  name: 'members',
  initialState,
  reducers: {
    setMembers: (state, action) => {
      state.membersGlobalState = action.payload;
    },
  },
});

export const members = membersSlice.reducer;
